module.exports = __webpack_public_path__ + "img/arrow - white.02b3479f.svg";